import React from 'react';
import { UniversalCalculator } from './UniversalCalculator';
import { inflationUniversalConfig } from './universalCalculatorConfigs';

export const InflationCalculator: React.FC = () => {
  return <UniversalCalculator config={inflationUniversalConfig} />;
};
